import styled from "styled-components";

export const RefrentInfo = styled.div`
  justify-self: auto;
  color: #4d4d4d;
  font-size: 14px;
  font-weight: 400;
  padding-left: 20px;
  padding-right: 1.375rem;
`;

export const SubsituteInfo = styled.div`
  justify-self: auto;
  color: #767676;
  font-size: 14px;
  font-weight: 400;
  padding-left: 20px;
  padding-right: 1.375rem;
`;

export const GridRowNoGap = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  font-weight: normal;
}
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;
